import { cn } from 'lib/helpers/utility';

const SpeechBubble = ({ children, className, variant = 'default', tail = 'none' }) => (
  <div className="relative">
    <div
      className={cn(
        'relative rounded-2xl px-5 py-4 text-sm leading-[1.7] shadow-sm',
        variant === 'default' && 'border border-solid border-neutral-200 bg-white text-neutral-700',
        variant === 'highlight' &&
          'border border-solid border-primary-200 bg-gradient-to-br from-primary-25 to-white text-primary-800',
        variant === 'dark' &&
          'border border-solid border-primary-300 bg-primary-50 text-primary-900',
        className
      )}>
      {children}
    </div>
    {tail === 'left' && (
      <div className="absolute -bottom-2 left-8 h-4 w-4 rotate-45 border-0 !border-b !border-r border-solid border-primary-200 bg-gradient-to-br from-primary-25 to-white" />
    )}
    {tail === 'right' && (
      <div className="absolute -bottom-2 right-8 h-4 w-4 rotate-45 border-0 !border-b !border-r border-solid border-primary-200 bg-gradient-to-br from-primary-25 to-white" />
    )}
  </div>
);

export default SpeechBubble;
